<template>
    <div class="partner">
        <com-returntop></com-returntop>
        <div class="partner-top">
            <div></div>
            <h1>合作伙伴</h1>
            <div></div>
        </div>
        <div class="partner-bottom">
            <div class="partner-bottom-box">
                <div class="partner-box-title">
                    <h2>专注仿真 - 想用户之所想</h2>
                    <p>完美工匠精神，为客户持续创造价值</p>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/2.png" alt="">
                    </div>
                </div>
                
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/4.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/5.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/6.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/7.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/8.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/9.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/10.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/12.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/13.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/14.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/15.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/16.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/17.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/18.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/19.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/20.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/21.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/22.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/23.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/24.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/26.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/27.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/28.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/29.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/30.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/31.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/32.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/33.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/34.png" alt="">
                    </div>
                </div>
                <div class="partner-box-img">
                    <div>
                        <img src="https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/35.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import comReturntop from "@/components/returntop";
export default {
    components: {
        comReturntop
    },
    data() {
        return {

        };
    },
    watch: {},
    created() {},
    mounted() {

    },
    methods: {

    }
};
</script>
<style>
.partner-top {
    display: flex;
    height: 150px;
    justify-content: center;
    align-items: center;
}
.partner-top div {
    width: 398px;
    height: 1px;
    background: #ddd;
    margin-top: 30px;
}
.partner-top h1 {
    font-size: 36px;
    color: #333;
    margin: 0 30px;
    margin-top: 30px;
}
.partner-bottom {
    width: 100%;
    background: #fff;
    padding-top: 40px;
    padding-bottom: 60px;
}
.partner-bottom-box {
    display: flex;
    flex-wrap: wrap;
    width: 1050px;
    margin: 0 auto;
}
.partner-box-title {
    width: 448px;
    padding-right: 70px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.partner-box-title h2 {
    font-size: 36px;
    color: #0055d3;
    text-align: right;
}
.partner-box-title p {
    font-size: 16px;
    color: #999;
    text-align: right;
}
.partner-box-img {
    background: #e7e7e7;
    position: relative;
    border: 4px solid #fff;
    width: 164px;
    height: 164px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.partner-box-img:hover div {
    background: url('https://bernouly.oss-cn-beijing.aliyuncs.com/images/partner/0.png') center no-repeat;
    background-size: 100% 100%;
    width: 220px;
    height: 220px;
    margin-left: -110px;
    margin-top: -110px;
    position: absolute;
    top: 50%;
    left: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
}
</style>